import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { BroadcastService, ModalService, ModalSize, SubContent } from '@cv-invision/core';
import { ORIGIN } from '../../model/nexsys-monitor.constant';
import { RequestInformationComponent } from '../request-information/request-information.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LOG_DETAIL } from '../../../value-link-monitor/model/value-link.model';
import { CvDateFormatter, DATEFORMAT } from '@cv-invision/cv.component-library.ux';

@Component({
	selector: 'cv-nexsys-log-description',
	templateUrl: './logs-description.component.html',
	styleUrls: ['./logs-description.component.scss']
})
export class LogsDescriptionComponent extends SubContent implements OnInit, OnDestroy {
	private atComponentDestroy: Subject<any> = new Subject<any>();
	nexsysLog: any;
	logsInputs: any;
	constructor(
		broadcastService: BroadcastService,
		private modalService: ModalService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private dateService: CvDateFormatter,
	) {
		super(broadcastService);
	}

	ngOnInit(): void {
		if (this.data) {
			switch (this.data.source) {
				case ORIGIN.NexsysLegacy:
					this.nexsysLog = [
						{ name: 'TransactionId', value: this.data.transactionId },
						{ name: 'Provider Order Identifier', value: this.data.providerOrderIdentifier },
						{ name: `${this.data.source} OrderId `, value: this.data.nexsysOrderId },
						{ name: 'IsException', value: this.data.isException },
						{ name: 'HttpCodeResponse', value: this.data.httpCodeResponse },
						{ name: 'Order Message', value: this.data.ordeMessage },
						{ name: 'Response Date', value: this.data.orderResponseDate }
					];
					break;

				case ORIGIN.ValueLink:
					this.nexsysLog = [
						{ name: 'Id', value: this.data.id },
						{ name: 'Transaction', value: this.data.transactionId },
						{ name: 'Provider Order Identifier', value: this.data.providerOrderIdentifier },
						{ name: `${this.data.source} Order ID`, value: this.data.valueLinkOrderId },
						{ name: 'Class Order ID', value: this.data.OrderId },
						{ name: 'Event Name', value: this.data.eventName },
						{ name: 'Value Link Order ID', value: this.data.valueLinkOrderId },
						{ name: 'Value Link Service ID', value: this.data.valueLinkServiceId },
						{ name: 'OrderId', value: this.data.OrderId },
						{ name: 'IsException', value: this.data.isException },
						{ name: 'HttpCodeResponse', value: this.data.httpCodeResponse },
						{ name: 'Response Date', value: this.dateService.format(DATEFORMAT.YYYY_MM_DD, this.data.orderResponseDate) },
						{ name: 'Duration', value: this.data.duration },
						{ name: 'Created', value: this.data.created },
						{ name: 'Received (Local)', value: this.dateService.format(DATEFORMAT.YYYY_MM_DD, this.data.created) }
					];
					break;
				
				case ORIGIN.Connexions:
					this.nexsysLog = [
						{ name: 'Id', value: this.data.id },
						{ name: 'Transaction', value: this.data.transactionId },
						{ name: 'Connexion Order Id', value: this.data.connexionsOrderId},
						{ name: 'Connexions Service Id', value: this.data.connexionsServiceId },
						{ name: 'Event Name', value: this.data.eventName },
						{ name: 'OrderId', value: this.data.OrderId },
						{ name: 'Duration', value: this.data.duration },
						{ name: 'Created', value: this.data.created },
					];
					break;
				case ORIGIN.Lendingqb:
					this.nexsysLog = [
						{ name: 'Id', value: this.data.id },
						{ name: 'Transaction', value: this.data.transactionId },
						{ name: 'Lending QB Order ID', value: this.data.lendingQbOrderId},
						{ name: 'Received (Local)', value: this.dateService.format(DATEFORMAT.YYYY_MM_DD, this.data.created) },
						{ name: 'Event Name', value: this.data.eventName },
						{ name: 'IsException', value: this.data.isException },
						{ name: 'HttpCodeResponse', value: this.data.httpCodeResponse },
					];
					break;
				case ORIGIN.LandGorilla:
					this.nexsysLog = [
						{ name: 'Id', value: this.data.id },
						{ name: 'Transaction', value: this.data.transactionId },
						{ name: 'Land Gorilla Order ID', value: this.data.landGorillaOrderId},
						{ name: 'Received (Local)', value: this.dateService.format(DATEFORMAT.YYYY_MM_DD, this.data.created) },
						{ name: 'Event Name', value: this.data.eventName },
						{ name: 'IsException', value: this.data.isException },
						{ name: 'HttpCodeResponse', value: this.data.httpCodeResponse },
					];
					break;

				default:
					let orderId = this.data.valutrustOrderId;
					switch (this.data.source) {
						case ORIGIN.Nexsys:
							orderId = this.data.nexsysOrderId;
							break;
						case ORIGIN.FNC:
							orderId = this.data.fncOrderId;
							break;
						case ORIGIN.EVO:
							orderId = this.data.evoOrderId;
							break;
					}

					this.nexsysLog = [
						{ name: 'TransactionId', value: this.data.transactionId },
						{ name: `${this.data.source} OrderId `, value: orderId },
						{ name: 'IsException', value: this.data.isException },
						{ name: 'Duration', value: this.data.duration + ' ms' },
						{ name: 'Status', value: this.data.status },
						{ name: 'HttpCodeResponse', value: this.data.httpCodeResponse },
						{ name: 'Order Message', value: this.data.ordeMessage },
						{ name: 'Response Date', value: this.data.orderResponseDate }
					];
					break;
			}

			const { request, response, orderApiResponse } = this.data;
			this.logsInputs = {
				request,
				response,
				orderApiResponse
			};
		}
		this.openSubContent(null, null);
	}	

	/**
	 * open modal request info
	 */
	displayRequestInfo(): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: RequestInformationComponent,
				data: {
					reuqest: { ...this.logsInputs, source: this.data.source }
				},
				modalConfiguration: {
					title: 'Payload Information',
					modalSize: ModalSize.XXL
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.status === 'accept' && result.definition) {
					//
				}
			});
	}

	/**
	 * On component destroy
	 */
	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
